import { FormatTimePassedUtc } from "../newComponents/GeneralClasses";

const EdifiedContentList = ({date_reacted,timestamp,personname,display_picture}) => {


    return (
        <div className="edifiedContentList">
               {
                display_picture && display_picture !== null ? <img id="blogProfile" src={display_picture} alt="" />
                :
                <svg
                viewBox="0 0 24 24"
                fill="#812072"
                height="30px"
                width="30px">
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z" />
                </svg>
                }
                {/* <div className="edified_list_right"> */}
                    <div className="edified_name_date">
                    {timestamp &&
                    <p style={{color:"orangered"}}>
                        {FormatTimePassedUtc(timestamp)}
                    </p> 
                   }

                   {personname && 
                   <p style={{fontWeight:"bold"}}>
                    {personname}
                   </p>
                   }
                    </div>
                {/* </div> */}
                <svg
                viewBox="0 0 24 24"
                fill="red"
                height="30px"
                width="30px">
                <path d="M20.205 4.791a5.938 5.938 0 00-4.209-1.754A5.906 5.906 0 0012 4.595a5.904 5.904 0 00-3.996-1.558 5.942 5.942 0 00-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412L12 21.414l8.207-8.207c2.354-2.353 2.355-6.049-.002-8.416z" />
                </svg>
        </div>
      );
}
export default EdifiedContentList;